import React from 'react';
import ContactForm from '../ContactForm/ContactForm';
import ContactHeader from '../ContactHeader/ContactHeader';

const Contact = () => {
    return (
        <div>
            <ContactHeader/>
            <ContactForm/>
        </div>
    );
};

export default Contact;